import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Spacing } from 'sugar-design';

import { getI18n } from '@/utils/i18n';

import styles from './index.cm.styl';
import './index.styl';

const i18n = getI18n();
/**
 * 弹窗组件
 * 支持国际化（参考国际化文档）
 */
class Dialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      showConfirmDialog: false,
    };

    this.onCloseDialog = this.onCloseDialog.bind(this);
    this.onCloseConfirmDialog = this.onCloseConfirmDialog.bind(this);
    this.onSubmitDialog = this.onSubmitDialog.bind(this);
    this.detectSelect = this.detectSelect.bind(this);
    this.setInnerHtml = this.setInnerHtml.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.forceOpenConfirmDialog) {
      this.setState({ showConfirmDialog: true });
    }
  }

  setInnerHtml(html) {
    return { __html: html };
  }

  onCloseDialog() {
    if (this.detectSelect()) {
      // eslint-disable-next-line react/no-unused-state
      return this.setState({ selectOpened: false });
    }

    if (this.props.confirmClosing && !this.state.showConfirmDialog) {
      return this.setState({ showConfirmDialog: true });
    }

    this.props.onCancel();
    this.setState({ tab: 0, showConfirmDialog: false });
  }

  onCloseConfirmDialog() {
    this.setState({ showConfirmDialog: false });
  }

  onSubmitDialog() {
    this.props.onSubmit();
    this.setState({ tab: 0 });
  }

  detectSelect() {
    const isOpen = !!document.querySelector('.Select-menu-outer');
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      selectOpened: isOpen,
    });
    return isOpen;
  }

  render() {
    const {
      isOpen,
      errorMessage,
      submitText = i18n.t`确认`,
      cancelText = i18n.t`取消`,
      deleteText = i18n.t`删除`,
      children,
      size,
      style,
      overlayStyle,
      disableSubmit,
      disableOutsideClick,
      isSubmitting,
      confirmClosing,
      confirmTitle = i18n.t`确认关闭？`,
      confirmSubtitle = i18n.t`检测到当前页面有未保存的内容，关闭后将丢失这部分信息。`,
      needCancelButton,
      needSubmitButton,
      hideTitle,
      hideFooter,
      needDeleteButton,
      subTitleExplaination,
      confirmSubmitText = i18n.t`确认关闭`,
      additionalSubmitText,
      disableCancel,
      onAdditionalSubmit,
      isAdditionalSubmiting,
      customFooterLeftComponent,
      customSubTitleComponent,
    } = this.props;
    const { tab, showConfirmDialog } = this.state;
    const titles = this.props.titles || [this.props.title];
    const subTitles = this.props.subTitles || [this.props.subTitle];
    const multi = titles.length > 1;

    // Only 3 sizes are available.
    // - "sm" width: 380px, height: auto
    // - "md" width: 640px, height: auto
    // - "lg" width: 780px, height: auto
    // - "mobile" width: 85%, height: auto
    let width = -1;
    if (size === 'lg') {
      width = 780;
    } else if (size === 'md') {
      width = 640;
    } else if (size === 'mobile') {
      width = '85%';
    } else if (size === 'new-sm') {
      // TODO: 以后要把 sm 大小的弹框做成另外一个 Dialog 组件（对应新的UI样式）
      // 而新 UI 中的最小号弹框实际上是490宽度（减掉左右padding是430）
      width = 430;
    } else if (size === 'qrcode') {
      // TODO: 二维码的弹框大小与之前的弹框都不一致
      width = 300;
    } else if (size === 'sm') {
      width = 380;
    } else {
      // unreachable since default size is md
      width = 380;
    }

    const modalStyle = {
      content: {
        width,
        position: 'static',
        padding: 30,
        overflow: 'visible',
        transition: 'margin-left .2s',
        ...style,
      },
      overlay: { backgroundColor: 'rgba(64, 68, 79, .35)', ...overlayStyle },
    };

    const headers = [];
    for (let i = 0; i < titles.length; i++) {
      const title = titles[i];
      const onChangeTab = () => this.setState({ tab: i });

      const titleStyle =
        this.props.titleStyle || 'dialog__header__title' + (multi && tab === i ? '--active' : '');

      headers.push(
        <div key={i} className={titleStyle} onClick={onChangeTab}>
          {title}
        </div>
      );
    }

    return (
      <Modal
        // eslint-disable-next-line react/forbid-component-props
        style={modalStyle}
        footerClassName={styles.customizeFooter}
        isOpen={isOpen}
        title={!hideTitle && headers}
        confirmText={submitText}
        cancelText={cancelText}
        isConfirmDisabled={disableSubmit}
        isConfirmLoading={!!isSubmitting}
        renderCustomFooter={({ onClose, onConfirm }) => (
          <div>
            {!hideFooter && (
              <div>
                <Spacing justify="end">
                  {!!needDeleteButton && (
                    <Button type="secondary" onClick={this.props.onDelete}>
                      {deleteText}
                    </Button>
                  )}
                  {customFooterLeftComponent}
                  {needCancelButton && (
                    <Button disabled={disableCancel} onClick={onClose}>
                      {cancelText}
                    </Button>
                  )}
                  {needSubmitButton && (
                    <Button
                      disabled={disableSubmit}
                      // hack coz tooltip--top triggers tooltip even when tooltip prop is falsy
                      loading={!!isSubmitting}
                      onClick={onConfirm}
                    >
                      {submitText}
                    </Button>
                  )}
                  {additionalSubmitText && (
                    <Button loading={!!isAdditionalSubmiting} onClick={onAdditionalSubmit}>
                      {additionalSubmitText}
                    </Button>
                  )}
                </Spacing>
              </div>
            )}
          </div>
        )}
        onClose={disableOutsideClick ? null : this.onCloseDialog}
        onConfirm={this.onSubmitDialog}
      >
        <div onClick={this.detectSelect}>
          <div className={'dialog__header__container' + (multi ? '--multi' : '')}>
            {multi && <div className="dialog__header__line" />}
            {customSubTitleComponent && (
              <div className="dialog__header__sub-title">{customSubTitleComponent}</div>
            )}
            {subTitles[tab] && <div className="dialog__header__sub-title">{subTitles[tab]}</div>}
            {subTitleExplaination && (
              <div className="dialog__header__sub-title-explaination">{subTitleExplaination}</div>
            )}
            {errorMessage &&
              (errorMessage instanceof React.Component ? (
                <div className="dialog__header__error">{errorMessage}</div>
              ) : (
                <div
                  className="dialog__header__error"
                  dangerouslySetInnerHTML={this.setInnerHtml(errorMessage)}
                />
              ))}
          </div>
          <div
            className={`dialog__body ${hideTitle ? 'no-title' : ''} ${
              hideFooter ? 'no-footer' : ''
            }`}
          >
            {multi ? children[tab] : children}
          </div>
        </div>
        {confirmClosing && showConfirmDialog && (
          <Modal
            isOpen={showConfirmDialog}
            title={confirmTitle}
            confirmText={confirmSubmitText}
            onClose={this.onCloseConfirmDialog}
            onConfirm={this.onCloseDialog}
          >
            {confirmSubtitle}
          </Modal>
        )}
      </Modal>
    );
  }
}

Dialog.defaultProps = {
  type: 'normal',
  size: 'md',
  style: {},
  overlayStyle: {},
  className: '',
  confirmClosing: false,
  disableSubmit: false,
  disableCancel: false,
  disableOutsideClick: false,
  needCancelButton: true,
  needSubmitButton: true,
  hideFooter: false,
  needDeleteButton: false,
};

Dialog.propTypes = {
  /**
   * 确认按钮的样式，只有预设的几个款式
   */
  size: PropTypes.oneOf(['lg', 'md', 'sm', 'mobile', 'new-sm', 'qrcode']),
  /**
   * 样式object
   * @deprecated 便于统一，不应该手动控制style
   */
  style: PropTypes.object,
  /**
   * 遮罩层样式
   * @deprecated 便于统一，不应该手动控制style
   */
  overlayStyle: PropTypes.object,
  /**
   * 主标题
   */
  title: PropTypes.node,
  /*
   * 标题样式
   */
  titleStyle: PropTypes.string,
  /**
   * 支持多标题
   * @deprecated 请使用StepDialog
   */
  titles: PropTypes.arrayOf(PropTypes.node),
  /**
   * 控制Dialog是否显示
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * 副标题
   */
  subTitle: PropTypes.node,
  /**
   * 支持多副标题
   * @deprecated 请使用StepDialog
   */
  subTitles: PropTypes.arrayOf(PropTypes.node),
  /**
   * 副标题描述..
   */
  subTitleExplaination: PropTypes.string,
  /**
   * 错误信息
   */
  errorMessage: PropTypes.string,
  /**
   * 确认按钮文字
   */
  submitText: PropTypes.string,
  /**
   * 取消按钮文字
   */
  cancelText: PropTypes.string,
  /**
   * 删除按钮文字
   */
  deleteText: PropTypes.string,
  /**
   * 取消按钮callback
   */
  onCancel: PropTypes.func,
  /**
   * 确定按钮callback
   */
  onSubmit: PropTypes.func,
  /**
   * 删除按钮callback
   */
  onDelete: PropTypes.func,
  /**
   * 是否禁用确定按钮
   */
  disableSubmit: PropTypes.bool,
  /**
   * 是否禁用取消按钮
   */
  disableCancel: PropTypes.bool,
  /**
   * 是否禁用点击遮罩层的效果
   */
  disableOutsideClick: PropTypes.bool,
  /**
   * 是否正在提交中，如果是true则默认显示loading状态
   */
  isSubmitting: PropTypes.bool,
  /**
   * 是否要对取消做二次确认，如果是true则当用户点击取消后会继续弹出一个小窗口二次确认
   */
  confirmClosing: PropTypes.bool,
  /**
   * 是否需要取消按钮
   */
  needCancelButton: PropTypes.bool,
  /**
   * 是否需要提交按钮
   */
  needSubmitButton: PropTypes.bool,
  /**
   * 是否需要删除按钮
   */
  needDeleteButton: PropTypes.bool,
  /**
   * 是否隐藏标题
   */
  hideTitle: PropTypes.bool,
  /**
   * 是否隐藏脚标题
   */
  hideFooter: PropTypes.bool,
  /**
   * 二次确认的文字
   */
  confirmSubmitText: PropTypes.string,
  /**
   * 二次确认的标题
   */
  confirmTitle: PropTypes.string,
  /**
   * 二次确认的副标题
   */
  confirmSubtitle: PropTypes.string,
  /**
   * 在确定按钮右侧添加一个附加按钮，和确定按钮样式一样
   */
  additionalSubmitText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /**
   * 参见additionalSubmitText
   */
  onAdditionalSubmit: PropTypes.func,
  /**
   * 参见additionalSubmitText
   */
  isAdditionalSubmiting: PropTypes.bool,
  /**
   * 自定义Footer组件
   */
  customFooterLeftComponent: PropTypes.element,
  /**
   * 自定义副标题
   */
  customSubTitleComponent: PropTypes.element,
};

export default Dialog;
